module.exports = __webpack_public_path__ + "static/media/img_5.c122427e.png";